import React, {PropsWithChildren} from 'react';
import classnames from 'classnames';

import {ACUD_PRO_PREFIX} from '../../../_common/constants';

import './index.less';

const CONTENT_PREFIX_CLS = `${ACUD_PRO_PREFIX}-page-layout__content`;

export interface ContentProps {
    className?: string;
    flexGrow?: number;
    style?: React.CSSProperties;
}

export interface ContentInterface extends React.FC<PropsWithChildren<ContentProps>> {}

const Content: ContentInterface = props => {
    const {className, flexGrow, children, style} = props;

    const contentCls = classnames(
        CONTENT_PREFIX_CLS,
        {
            [`${CONTENT_PREFIX_CLS}--flex-grow`]: flexGrow !== undefined && flexGrow >= 1
        },
        className
    );

    return (
        <div
            className={contentCls}
            style={{...style, flexGrow}}
        >
            {children}
        </div>
    );
};

export default Content;